const superagent = require("superagent");
const R = require("ramda");
const jwt = require("jsonwebtoken");

export default class Auth {
  constructor(url, appUrl) {
    this.serverUrl = url || "http://localhost:3001";
    this.appUrl = appUrl || "http://localhost:3000";
  }

  static setTokens({ accessToken, idToken, refreshToken }) {
    // eslint-disable-next-line no-debugger
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("id_token", idToken);
    localStorage.setItem("refresh_token", refreshToken);
  }

  static getTokens() {
    return {
      accessToken: localStorage.getItem("access_token"),
      idToken: localStorage.getItem("id_token"),
      refreshToken: localStorage.getItem("refresh_token")
    };
  }

  static removeTokens() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("refresh_token");
  }

  static parseUrlForTokens(url) {
    const params = url.split("?")[1];
    if (!params) return {};

    return params.split("&").reduce((acc, curr) => {
      const [key, value] = curr.split("=");
      acc[key] = value;
      return acc;
    }, {});
  }

  login = async ({ username, password, redirectUri }, cb) => {
    if (!password || !password.toString().trim()) {
      cb("Password is required");
      return;
    }

    try {
      const res = await superagent
        .post(`${this.serverUrl}/user/auth/login`)
        .send({ username, password });

      const tokens = {
        accessToken: R.pathOr(
          undefined,
          ["body", "payload", "access_token"],
          res
        ),
        idToken: R.pathOr(undefined, ["body", "payload", "id_token"], res),
        refreshToken: R.pathOr(
          undefined,
          ["body", "payload", "refresh_token"],
          res
        )
      };

      if (!tokens.accessToken || !tokens.idToken || !tokens.refreshToken) {
        throw new Error("No token found");
      }
      Auth.setTokens(tokens);
      window.location.replace(redirectUri || `${this.appUrl}/home`);
    } catch (err) {
      cb(err);
    }
  };

  logout() {
    window.location.href = `${this.serverUrl}/sso/saml/logout?token=${
      Auth.getTokens().accessToken
    }`;
  }

  checkSession(options, callback) {
    let { accessToken, idToken } = Auth.getTokens();

    if (!accessToken || !idToken) {
      const tokensFromUrl = Auth.parseUrlForTokens(window.location.href);
      if (tokensFromUrl.accessToken && tokensFromUrl.idToken) {
        Auth.setTokens(tokensFromUrl);
        ({ accessToken, idToken } = tokensFromUrl);
        const redirectUri = localStorage.getItem("redirect_url");
        localStorage.removeItem("redirect_url");
        window.location.replace(redirectUri || `${this.appUrl}/home`);
      }
    }

    if (accessToken && idToken) {
      if (!this.isValidToken(accessToken)) {
        this.refreshToken(Auth.getTokens().refreshToken)
          .then(() => {
            ({ accessToken, idToken } = Auth.getTokens());
            callback(null, { accessToken, idToken });
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
            Auth.removeTokens();
            callback("Refresh token operation failed", null);
          });
      } else {
        callback(null, { accessToken, idToken });
      }
    } else {
      callback("No token found", null);
    }
  }

  refreshToken = async token => {
    if (!token) {
      throw new Error("No refresh token found");
    }
    const decodedToken = jwt.decode(token);
    const time = new Date().getTime();
    const tokenTime = decodedToken.exp * 1000;
    if (time > tokenTime) {
      throw new Error("Refresh token has expired");
    }
    try {
      const result = await superagent
        .post(`${this.serverUrl}/user/auth/refresh-token`)
        .send({ token });
      Auth.removeTokens();
      Auth.setTokens({
        accessToken: R.pathOr(
          undefined,
          ["body", "payload", "access_token"],
          result
        ),
        idToken: R.pathOr(undefined, ["body", "payload", "id_token"], result),
        refreshToken: R.pathOr(
          undefined,
          ["body", "payload", "refresh_token"],
          result
        )
      });
    } catch (err) {
      Auth.removeTokens();
      throw new Error("Refresh token operation failed");
    }
  };

  isValidToken(token) {
    if (!token) return false;
    const decodedToken = jwt.decode(token);
    return new Date().getTime() < decodedToken.exp * 1000;
  }
}
